// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"6810ea5a","331":"5b43a383","333":"0f5dc578","503":"5dd30162","651":"d0fde8c4","942":"2d94c339","995":"9c1960fd"}[chunkId] + ".chunk.css";
};